package com.dwarshb.bms

import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.verticalScroll
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.Block
import androidx.compose.material.icons.filled.BookmarkAdd
import androidx.compose.material.icons.filled.DirectionsCar
import androidx.compose.material3.Button
import androidx.compose.material3.ButtonDefaults
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.Icon
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.OutlinedButton
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.rotate
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.mohamedrejeb.calf.ui.sheet.AdaptiveBottomSheet
import com.mohamedrejeb.calf.ui.sheet.rememberAdaptiveSheetState

@Composable
fun SeatLayout(seats: List<BusSeat>,
               coachType: String,
               deck: String = "",
               leftSeats: Int,
               rightSeats: Int,
               backSeats: Int,
               selectedSeats: List<String>,
               selectedSeatsColor: Color = Color.Green,
               hideAvailableSeatsText: Boolean = false,
               hideConfirmButton: Boolean = false,
               onSeatSelected: (String) -> Unit,
               confirmSeatLayout: (BusLayout,List<String>) -> Unit = {_,_ ->}) {

    LazyColumn(
        modifier = Modifier
            .fillMaxWidth()
            .padding(16.dp)
        ,
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        val rowSeats = leftSeats + rightSeats
        val totalRows = if(coachType=="Sleeper") {
            (seats.size - (backSeats*2))/(rowSeats*2)
        } else {
            (seats.size - backSeats) / rowSeats
        }
        val aisleWidth = 50.dp
        if(!hideAvailableSeatsText) {
            item {
                Text(
                    "Total Available Seats ${seats.size - selectedSeats.size}",
                    modifier = Modifier.fillMaxWidth(),
                    textAlign = TextAlign.Center
                )
            }
        }
        items(totalRows) { rowIndex ->
            Row(
                modifier = Modifier
                    .padding(vertical = 8.dp),
                horizontalArrangement = Arrangement.spacedBy(aisleWidth)
            ) {
                Row(horizontalArrangement = Arrangement.spacedBy(4.dp)) {
                    repeat(leftSeats) { seatIndex ->
                        val number = rowIndex * rowSeats + seatIndex + 1
                        val seatNumber = if (deck.isNotEmpty()) "$deck $number" else number.toString()
                        if(number<=seats.size) {
                            Seat(BusSeat(seatNumber, coachType,seats.get(number).isBooked), selectedSeatsColor, selectedSeats, onSeatSelected = {
                                onSeatSelected(it)
                            })
                        }
                    }
                }
                Row(horizontalArrangement = Arrangement.spacedBy(4.dp)) {
                    repeat(rightSeats) { seatIndex ->
                        val number = rowIndex * rowSeats + leftSeats + seatIndex + 1
                        val seatNumber = if (deck.isNotEmpty()) "$deck $number" else number.toString()
                        if(number<=seats.size) {
                            Seat(BusSeat(seatNumber, coachType,seats.get(number).isBooked), selectedSeatsColor, selectedSeats, onSeatSelected = {
                                onSeatSelected(it)
                            })
                        }
                    }
                }
            }
        }
        if (backSeats!=0) {
            item {
                Row(horizontalArrangement = Arrangement.spacedBy(4.dp)) {
                    repeat(backSeats) { seatIndex ->
                        val number = seats.size - backSeats + seatIndex + 1
                        val seatNumber = if (deck.isNotEmpty()) "$deck ${seats.get(number-1).id}" else seats.get(number-1).id
                        if(number<=seats.size) {
                            Seat(BusSeat(seatNumber, coachType,seats.get(number-1).isBooked), selectedSeatsColor, selectedSeats, onSeatSelected = {
                                onSeatSelected(it)
                            })
                        }
                    }
                }
            }
        }
        if(!hideConfirmButton) {
            item {
                Spacer(modifier = Modifier.height(24.dp))
                OutlinedButton(
                    onClick = {
                        val busLayout = BusLayout(leftSeats, rightSeats, backSeats)
                        confirmSeatLayout(busLayout, selectedSeats)
                    },
                    colors = ButtonDefaults.buttonColors(
                        containerColor = Color(0xFFD81B60),
                        contentColor = Color.White
                    )
                ) {
                    Text("Confirm")
                }
            }
        }
    }
//    LazyVerticalGrid(
//        columns = GridCells.Fixed(4),
//        modifier = Modifier.fillMaxSize()
//    ) {
//        items(viewModel.seats) { seat ->
//            Box(
//                modifier = Modifier
//                    .padding(4.dp)
//                    .size(40.dp)
//                    .background(
//                        when {
//                            seat.isBooked -> Color.Gray
//                            viewModel.selectedSeats.contains(seat.id) -> Color.Green
//                            else -> Color.LightGray
//                        }
//                    )
//                    .clickable(
//                        enabled = !seat.isBooked,
//                        onClick = { viewModel.selectSeat(seat.id) }
//                    ),
//                contentAlignment = Alignment.Center
//            ) {
//                Text(seat.id.toString())
//            }
//        }
//    }
}

@Composable
fun Seat(seat: BusSeat, selectedSeatsColor: Color, selectedSeats: List<String>,onSeatSelected: (String) -> Unit) {
    val busType = seat.seatType
    val seatNumber = seat.id
    val shape = if (busType == "Sleeper") RoundedCornerShape(4.dp) else RoundedCornerShape(8.dp)
    val seatLabel = seatNumber
    Box(
        modifier = Modifier
            .width(50.dp)
            .height(if (busType == "Sleeper") 100.dp else 50.dp)
            .padding(4.dp)
            .background(Color(0xFF0066CC), shape = shape)
            .background(
                when {
                    seat.isBooked ->
                        Color.Red
                    selectedSeats.contains(seat.id) ->
                        selectedSeatsColor
                    else ->
                        Color.LightGray
                }
            )
            .clickable(
                enabled = !seat.isBooked,
                onClick = { onSeatSelected(seat.id) }
            ),
        contentAlignment = Alignment.Center
    ) {
        Text(
            text = seatLabel,
            color = Color.White,
            fontSize = 16.sp,
            fontWeight = FontWeight.Bold
        )
    }
}

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun seatDialog(actionType: String,seatNumber: String, action: (String) -> Unit) {
    val adaptiveSheetState = rememberAdaptiveSheetState()
    AdaptiveBottomSheet(
        onDismissRequest = { action("") },
        adaptiveSheetState = adaptiveSheetState) {
        Column(modifier = Modifier.padding(24.dp).align(Alignment.CenterHorizontally)) {
            Text("Seat Number: $seatNumber",
                style = MaterialTheme.typography.titleLarge)
            Spacer(modifier = Modifier.height(24.dp))
            Button(
                colors = ButtonDefaults.buttonColors(
                    containerColor = Color.Red, contentColor = Color.White),
                onClick = {action(actionType)}){
                Icon(Icons.Default.Block,"")
                Text(" $actionType")
            }
        }
    }
}